/* ==========================================================================
   VITAL VIAL - Cart drawer
   Opens on cart-icon click and after add-to-cart. Re-renders from the server
   whenever the cart changes, so totals and the shipping bar stay accurate.
   Quantity changes and removals inside the drawer keep it open (the shopper
   stays where they were). On the cart page itself, cart changes do not pop
   the drawer open over the page.
   Product-card "Add to cart" buttons (form[data-vv-quick-add]) add over fetch
   and open the drawer, so shoppers stay on the page they were browsing.
   Links to /cart inside the drawer itself (e.g. "View cart") navigate normally.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var release = null, opener = null, busBound = false, seq = 0;
  // Set by any refresh that should open the drawer. Kept across refreshes so a
  // later refresh(false) (e.g. the cart:refresh event fired right after an add)
  // cannot cancel the open that the add-to-cart asked for.
  var wantOpen = false;

  function el() { return document.querySelector('[data-vv-cart-drawer]'); }
  function onCartPage() { return !!document.querySelector('.vv-cart-section'); }

  function trap() {
    var d = el();
    var panel = d && d.querySelector('.vv-drawer-cart__panel');
    if (release) { release(); release = null; }
    if (window.vvTrapFocus && panel) release = window.vvTrapFocus(panel, close);
  }

  function open() {
    var d = el();
    if (!d) return;
    if (!d.classList.contains('is-open')) opener = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vv-no-scroll');
    trap();
  }

  function close() {
    var d = el();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vv-no-scroll');
    if (release) { release(); release = null; }
    if (opener && opener.focus && document.contains(opener)) opener.focus();
  }

  window.vvCartDrawer = { open: open, close: close };

  /* ---- Re-render from the server --------------------------------------- */
  function refresh(thenOpen) {
    var d = el();
    if (!d) return;
    var m = (d.closest('[id^="shopify-section-"]') || {}).id || '';
    var id = m.replace('shopify-section-', '');
    if (!id) return;
    if (thenOpen) wantOpen = true;
    var mine = ++seq;

    fetch(ROOT + '?section_id=' + id)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (mine !== seq) return; // a newer refresh is on its way
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-vv-cart-drawer]');
        if (!fresh) return;
        var wasOpen = d.classList.contains('is-open');
        var scroller = d.querySelector('.vv-drawer-cart__body');
        var keepScroll = scroller ? scroller.scrollTop : 0;
        d.innerHTML = fresh.innerHTML;
        if (wasOpen) {
          // Still open: keep the shopper's place and focus inside the drawer.
          var body = d.querySelector('.vv-drawer-cart__body');
          if (body) body.scrollTop = keepScroll;
          trap();
          if (!d.contains(document.activeElement)) {
            var focusTo = d.querySelector('[data-vv-cart-drawer-close].vv-icon-btn') || d.querySelector('.vv-drawer-cart__panel');
            if (focusTo && focusTo.focus) focusTo.focus({ preventScroll: true });
          }
        } else if (wantOpen) {
          open();
        }
        wantOpen = false;
      })
      .catch(function () {});
  }

  /* ---- Triggers --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vv-cart-drawer-close]')) { e.preventDefault(); close(); return; }

    // Cart icon opens the drawer rather than navigating.
    // Links inside the drawer (e.g. "View cart") and links marked
    // data-vv-cart-page go to the cart page as normal.
    var d = el();
    var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (cartLink && d && !d.contains(cartLink) && !cartLink.hasAttribute('data-vv-cart-page') && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      refresh(true);
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = el();
    if (e.key === 'Escape' && d && d.classList.contains('is-open')) close();
  });

  // Open automatically after a successful add-to-cart (not on the cart page,
  // where the page itself already shows the change).
  if (window.vvBus) {
    window.vvBus.on('cart:updated', function () { refresh(!onCartPage()); });
    busBound = true;
  }
  document.addEventListener('cart:refresh', function () { refresh(false); });

  /* ---- Quick add from product cards ------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-vv-quick-add]')) return;
    if (!window.fetch || !window.FormData || !el()) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch(ROOT + 'cart.js').then(function (c) { return c.json(); });
      })
      .then(function (cart) {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
        if (window.vvBus) window.vvBus.emit('cart:updated', cart);
        if (!busBound) {
          refresh(true);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function () {
        // Fall back to the normal form post (shows Shopify's own message)
        form.submit();
      });
  });
})();
